import React, { useEffect, useState } from 'react';
import { Form, Input, Layout, message, Row, Col, Checkbox } from 'antd';
import 'react-quill-new/dist/quill.snow.css';

import RoleApi from 'services/role';
import PdButton from 'components/pd-button';
import './style.scss';
import { get } from 'lodash';
import { useLocation, useNavigate } from 'react-router-dom';

const { Content } = Layout;

const FIELDS = {
  TITLE: 'title',
  PAGE_PERMISSION: 'page_permission',
  ADMINS: 'admins',
};

export function RoleCreateEdit() {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [value, setValue] = useState({});
  const [loadingButton, setLoadingButton] = useState(false);
  const [permissionPage, setPermissionPage] = useState([]);
  const [pageList, setPageList] = useState([]);

  const [formLayout] = useState('vertical');

  const location = useLocation();
  const urlParams = new URLSearchParams(location.search);
  const id = urlParams.get('id');

  const formItemLayout =
    formLayout === 'horizontal'
      ? {
          labelCol: { span: 4 },
          wrapperCol: { span: 14 },
        }
      : null;

  const buttonItemLayout =
    formLayout === 'horizontal'
      ? {
          wrapperCol: { span: 14, offset: 4 },
        }
      : null;

  async function getRole(id) {
    try {
      const { data } = await RoleApi.getRole(id);
      const role = data.data;
      const permissionPage = get(role, 'permission', []).map((permit) => {
        const newPermit = permit.page;
        return newPermit;
      });
      setPermissionPage(permissionPage);
      setValue(role);
      form.setFieldsValue({ [FIELDS.TITLE]: role[FIELDS.TITLE] });
    } catch (err) {
      const errMessage = get(
        get(get(err, 'response', {}), 'data', {}),
        'message',
        ''
      );
      if (errMessage) {
        message.error(errMessage);
      } else {
        message.error('Cannot connect to server, please check connection');
      }
    }
  }

  async function getPages() {
    try {
      const { data } = await RoleApi.getPages();
      const pages = data.data;
      const newPages = pages.map((list) => {
        let display = list.page;
        if (list.page === 'users') {
          display = 'customers';
        }
        if (list.page === 'product_collections') {
          display = 'collections';
        }
        if (list.page === 'terms_and_conditions') {
          display = 'terms_and_policy';
        }
        list.displayPage = display;
        return list;
      });
      setPageList(newPages);
    } catch (err) {
      const errMessage = get(
        get(get(err, 'response', {}), 'data', {}),
        'message',
        ''
      );
      if (errMessage) {
        message.error(errMessage);
      } else {
        message.error('Cannot connect to server, please check connection');
      }
    }
  }

  function convertPage(page) {
    let str = page.split('_');
    str = str.map((item) => {
      return item.charAt(0).toUpperCase() + item.slice(1);
    });
    return str.join(' ');
  }

  useEffect(() => {
    getPages();
  }, []);

  useEffect(() => {
    if (id) {
      getRole(id);
    } else {
      setValue([]);
    }
  }, [navigate, id]);

  async function onFinish(values) {
    try {
      delete value['permission'];
      values[FIELDS.PAGE_PERMISSION] = permissionPage;
      setLoadingButton(true);
      if (id) {
        await RoleApi.updateRole(id, { ...value, ...values });
        message.success('Successfully updated role');
      } else {
        values[FIELDS.ADMINS] = [];
        await RoleApi.createRole({ ...value, ...values });
        message.success('Successfully created role');
      }
      navigate({
        pathname: '/roles',
      });
    } catch (err) {
      const errMessage = get(
        get(get(err, 'response', {}), 'data', {}),
        'message',
        ''
      );
      if (errMessage) {
        message.error(errMessage);
      } else {
        message.error('Cannot connect to server, please check connection');
      }
    } finally {
      setLoadingButton(false);
    }
  }

  function changeValue(e, key) {
    if (e) {
      setValue((prevState) => ({
        ...prevState,
        [key]: e.target.value,
      }));
    }
  }

  function addPage(check, pageName) {
    const newPageList = permissionPage.slice();
    if (check) {
      newPageList.push(pageName);
      setPermissionPage(newPageList);
    } else {
      const index = newPageList.indexOf(pageName);
      newPageList.splice(index, 1);
      setPermissionPage(newPageList);
    }
  }

  return (
    <Layout className="pd-cms-role main-container">
      <div className="container">
        <div className="content">
          <div className="pageTitle">{id ? 'Edit' : 'Create New'} Role</div>
          <Content className="pageContent">
            <Form
              layout={formLayout}
              form={form}
              onFinish={onFinish}
              initialValues={{
                [FIELDS.TITLE]: value[FIELDS.TITLE],
              }}>
              <div className="section-container">
                <div className="inner-section">
                  <Form.Item
                    label="Title"
                    name={FIELDS.TITLE}
                    {...formItemLayout}
                    rules={[
                      { required: true, message: 'Please input Title!' },
                    ]}>
                    <Input
                      placeholder="Write role name here"
                      onChange={(e) => changeValue(e, FIELDS.TITLE)}
                    />
                  </Form.Item>
                  <Row>
                    <Col span={24}>
                      <label title="Products">Page Permission</label>
                    </Col>
                    <Col span={24}>
                      <Row gutter={[20, 20]} className="pd-cms-role--page-list">
                        {pageList.map((list, i) => (
                          <Col span={12} key={i}>
                            <Checkbox
                              checked={permissionPage.includes(list.page)}
                              onChange={(e) =>
                                addPage(e.target.checked, list.page)
                              }
                            />
                            <span className="page-name">
                              {convertPage(list.displayPage)}
                            </span>
                          </Col>
                        ))}
                      </Row>
                    </Col>
                  </Row>
                </div>
                <Form.Item {...buttonItemLayout}>
                  <div className="buttonSection mt-40">
                    <PdButton
                      htmlType="submit"
                      loading={loadingButton}
                      type="primary"
                      full>
                      Publish
                    </PdButton>
                  </div>
                </Form.Item>
              </div>
            </Form>
          </Content>
        </div>
      </div>
    </Layout>
  );
}

export default RoleCreateEdit;
